import { IconButton, FontIcon } from '@fluentui/react';
import { ChatMessage } from './ChatMessage';
import { BotAvatar } from '../BotAvatar';
import styles from './ChatConversation.module.sass';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';

interface ChatConversationProps {
    conversation: any;
    pendingRequest: boolean;
    submitInput: (input: string) => void;
    onFeedback: (index: number, isPositive: boolean) => void;
    resourceSelected?: (resource: any) => void;
}

export const ChatConversation = ({
    conversation,
    pendingRequest,
    submitInput,
    onFeedback,
    resourceSelected,
}: ChatConversationProps) => {
    const { t } = useTranslation();
    const messagesEndRef = useRef(null) as any;

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
    }

    // TODO Probably move this to the ChatExchange component
    useEffect(() => {
        scrollToBottom()
    }, [conversation]);

    return (
        <>
            <div className="messagesContainer">
                {conversation && conversation.messages && conversation.messages.length > 0
                    ?
                    <div className='messages'>
                        {conversation.messages.map((message: any, index: number) => (
                            <ChatMessage
                                key={index}
                                message={message}
                                index={index}
                                isLastMessage={index === conversation.messages.length - 1}
                                onSubmitInput={submitInput}
                                onFeedback={onFeedback}
                                resourceSelected={resourceSelected}
                            />
                        ))}
                        {pendingRequest ?
                            <div className={styles.messageContainer}>
                                <BotAvatar />
                                <div className={styles.chatBotMessage}>
                                    <div className={styles.chatBotMessageArrow}></div>
                                    <div className="spinner-box">
                                        <div className="pulse-container">
                                            <div className="pulse-bubble pulse-bubble-1"></div>
                                            <div className="pulse-bubble pulse-bubble-2"></div>
                                            <div className="pulse-bubble pulse-bubble-3"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <></>}
                        <div ref={messagesEndRef}></div>
                    </div>
                    :
                    <></>
                }
            </div>
        </>
    );
}; 